<template>
  <v-card v-if="userAuthorized" flat>
    <!-- ------------- COMPONENT --------------- -->
    <sl-titlebar instructions="browse checklists and edit entries" :sticky="20">
      <template #title>
        <v-form ref="titleForm" class="grow" v-model="titleFormIsValid">
          <sl-text-field
            v-model="master.title"
            :rules="titleRules"
            textarea
            label="Title"
            name="title"
            type="text"
            class="text-h5 mb-2 mb-sm-0"
            :hide-details="titleFormIsValid"
            @focus="onTitleEditing"
            @update="titleUpdate"
          >
            <template #prepend>
              <v-icon size="30" color="master">
                mdi-vector-square
              </v-icon>
            </template>
          </sl-text-field>
        </v-form>
        <br class="d-flex d-sm-none" />
      </template>
      <!-- <template #avatars>
        <sl-avatar
          v-for="user in master.currentlyOnUsers"
          :key="user.id"
          :user="user"
          class="ml-2"
        />
      </template> -->
      <template #actions>
        <!-- <v-row no-gutters align="center" justify="space-around" justify-sm="end">
          <v-col class="text-center"> -->
        <sl-btn-instance-create
          iconAlternative
          :outlined="$vuetify.breakpoint.smAndUp"
          color="instance"
          :master="master"
          class="mx-1"
        >
          <template v-if="$vuetify.breakpoint.smAndUp"> new checklist</template>
        </sl-btn-instance-create>
        <v-spacer class="d-flex d-sm-none"></v-spacer>
        <!-- </v-col>
          <v-col class="text-center"> -->
        <sl-btn-master-duplicate :master="master" />
        <v-spacer class="d-flex d-sm-none"></v-spacer>
        <!-- </v-col>
          <v-col class="text-center"> -->
        <sl-btn-share-permalink v-if="masterSharable" :permalink="permalink" objectType="master" />
        <v-spacer class="d-flex d-sm-none"></v-spacer>
        <!-- </v-col>
          <v-col class="text-center"> -->
        <sl-btn-delete :disabled="!masterDeletable" objectType="master" :object="master" />
        <!-- </v-col>
        </v-row> -->
      </template>
    </sl-titlebar>
    <v-progress-linear :active="loadingData" indeterminate color="master"></v-progress-linear>
    <!-- ------------- COMPONENT --------------- -->

    <!-- <v-card-text>
      <sl-metadata objectType="master" :object="master" />
    </v-card-text> -->

    <!-- <v-row no-gutters> -->
    <v-row>
      <v-col cols="12" sm="9">
        <v-tabs v-model="tab" icons-and-text grow color="master">
          <v-tab>
            <span v-if="$vuetify.breakpoint.smAndUp">Browse checklists</span>
            <span v-else>Checklists</span>
            <v-icon>mdi-format-list-checks</v-icon>
          </v-tab>
          <v-tab>
            Edit entries
            <v-icon>mdi-checkbox-marked-outline</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <!--------------- MasterChecklists.vue ---------------->
            <master-checklists v-if="master.id" :master="master" />
            <!----------------------------------------------------->
          </v-tab-item>
          <v-tab-item>
            <!--         MasterEntries.vue            -->
            <master-entries :ref="'entrylist'" v-if="master.id" :master="master" />
            <!------------------------------------------>
          </v-tab-item>
        </v-tabs-items>
      </v-col>

      <v-col cols="12" sm="3">
        <sl-metadata
          objectType="master"
          :object="master"
          showAvatar
          :sticky="160"
          class="pl-4 pl-sm-0"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import ClMaster from '@/models/ClMaster'
import Session from '@/models/Session'
// import router from '@/router'

import MasterChecklists from '@/components/MasterChecklists'
import MasterEntries from '@/components/MasterEntries'

// import InstanceCard from '@/components/InstanceCard'
import SlTextField from '@/components/SlTextField'
import SlTitlebar from '@/components/SlTitlebar'
// import SlAvatar from '@/components/SlAvatar'
import SlBtnMasterDuplicate from '@/components/SlBtnMasterDuplicate'
import SlBtnInstanceCreate from '@/components/SlBtnInstanceCreate'
import SlBtnDelete from '@/components/SlBtnDelete'
import SlBtnSharePermalink from '@/components/SlBtnSharePermalink'
import SlMetadata from '@/components/SlMetadata'

export default {
  components: {
    MasterChecklists,
    MasterEntries,
    SlTextField,
    SlTitlebar,
    // SlAvatar,
    SlBtnMasterDuplicate,
    SlBtnInstanceCreate,
    SlBtnDelete,
    SlBtnSharePermalink,
    SlMetadata,
  },

  data() {
    return {
      master: {
        title: '',
        creator: {
          id: '',
          firstName: '',
          lastName: '',
        },
        createdAt: '',
      },
      permalink: '',
      scrollingOptions: {
        duration: 300,
        offset: 50,
        easing: 'easeInOutCubic',
      },
      tab: {},
      titleBackup: '',
      titleFormIsValid: true,
      titleRules: [v => !!v || 'Required', v => (v && v.length <= 96) || 'Max 96 characters'],
      loadingData: true,
      userAuthorized: true,
      userAccessType: '',
    }
  },

  watch: {
    async $route(/*to, from*/) {
      // react to route changes...
      ClMaster.notifyLeave(this.master.id)
      this.queryCreate()
    },
  },

  computed: {
    //
    masterDeletable() {
      return this.userLogged.id === this.master.creator.id || this.userAccessType === 'admin'
    },
    masterSharable() {
      return this.userAccessType !== 'private'
    },
    ...mapState(['userLogged']),
  },

  created() {
    const baseUrl = 'https://app.sharylist.com/' // FIXME: da spostare in un file di costanti o in env
    this.permalink = baseUrl + 'model/' + this.$route.params.masterId
    this.errorsDataAccessAllSetFalse()
    this.queryCreate()
  },

  mounted() {
    //
  },

  beforeDestroy() {
    Logger.debug(this.queries)
    this.queries.forEach(q => q.destroy())
    ClMaster.notifyLeave(this.master.id)
  },

  methods: {
    queryCreate() {
      if (this.queries) this.queries.forEach(q => q.destroy())
      this.queries = [
        ClMaster.find({
          get: `{
            id,
            title,
            workspace {
              id, name
            },
            actionsAllowed {
              instanceCreate,
              selfDuplicate,
              entryCreate
            },
            creator {
              id, firstName, lastName
            },
            createdAt,
            lastEntryUpdate {
              user {
                id, firstName, lastName
              },
              time
            },
            currentlyOnUsers {
              id, firstName, lastName
            },
            instancesNumber,
            lastInstance {
              id,
              creator {
                id, firstName, lastName
              },
              createdAt
            },
            clEntries {
              id,
              deletedAt,
              entryText,
              orderPosition,
              historyKey,
              history {
                id,
                entryText,
                deletedAt
                orderPosition,
              }
            },
          }`,
          by: { id: this.$route.params.masterId },
          onChange: data => {
            Logger.debug('[Master.vue] - onChange')
            this.errorsDataAccessAllSetFalse()
            this.nodeCurrentSet({
              workspace: {
                id: data.workspace.id,
                name: data.workspace.name,
              },
              master: {
                id: data.id,
                title: data.title,
              },
            })
            this.master = data
            if (!this.tab) this.tab = this.master.lastInstance ? 0 : 1
            this.loadingData = false
          },
          onError: error => {
            this.loadingData = false
            Logger.error('ERROR in loading data:', error)
            switch (error.name) {
              case 'UNAUTHORIZED_TO_WORKSPACE':
                this.errorDataUnauthorizedAccessSet(true) // FIXME: non dovrebbe più essere necessario qui
                this.userAuthorized = false
                Session.clear()
                break
              case 'MASTER_MISSING':
                this.errorDataMissingSet(true)
                Session.clear()
                break
              default:
                this.toastSet({
                  message: 'Error in loading data',
                  color: 'error',
                })
            }
          },
        }),

        ClMaster.userAccess({
          clMasterId: this.$route.params.masterId,
          userId: this.userLogged.id,
          onChange: data => {
            this.errorsDataAccessAllSetFalse()
            this.userAccessType = data.accessType
          },
          onError: error => {
            Logger.error('ERROR in loading user access data:', error)
            switch (error.name) {
              case 'UNAUTHORIZED_TO_MASTER':
                this.errorDataUnauthorizedAccessSet(true)
                this.userAuthorized = false
                Session.clear()
                break
              case 'MASTER_MISSING':
                this.errorDataMissingSet(true)
                Session.clear()
                break
              default:
                this.toastSet({
                  message: 'Error in loading user access data',
                  color: 'error',
                })
            }
          },
        }),
      ]
    },
    onTitleEditing() {
      this.titleBackup = this.master.title
    },
    async titleUpdate() {
      if (this.master.title !== this.titleBackup) {
        if (this.titleFormIsValid) {
          try {
            Logger.debug('titleUpdate', this.master.id, this.master.title)
            await ClMaster.save(this.master)
            this.titleBackup = this.master.title
            this.toastSet({
              message: 'Model title successfully changed',
              color: 'success',
            })
          } catch (e) {
            this.master.title = this.titleBackup
            Logger.error(e)
            if (e.name === 'TITLE_ALREADY_PRESENT') {
              this.toastSet({
                message: 'Error: a model with such title already exists in this workspace',
                color: 'error',
              })
            } else {
              this.toastSet({
                message: 'Error in updating model title',
                color: 'error',
              })
            }
          }
        } else {
          this.master.title = this.titleBackup
          this.toastSet({
            message: 'Error in title text validation, restoring previous title',
            color: 'error',
          })
        }
      }
    },
    instanceCreate() {
      Logger.warn('instanceCreate to be implemented!')
    },
    ...mapMutations([
      'nodeCurrentSet',
      'toastSet',
      'errorDataUnauthorizedAccessSet',
      'errorDataMissingSet',
      'errorsDataAccessAllSetFalse',
    ]),
  },
}
</script>

<style scoped></style>
